import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationDetailComponent } from './organization-detail.component';
import { OrganizationEditComponent } from './organization-edit.component';
import { CommunicationSelectorComponent } from './components/communication-selector.component';
import { OrganizationContactsComponent } from './components/organization-contacts.component';
import { OrganizationDepartmentsComponent } from './components/organization-departments.component';
import { OrganizationFilesComponent } from './components/organization-files.component';
import { OrganizationFormComponent } from './components/organization-form.component';
import { OrganizationHistoryComponent } from './components/organization-history.component';
import { OrganizationListComponent } from './components/organization-list.component';
import { OrganizationNotesComponent } from './components/organization-notes.component';
import { LunaCommonModule } from '../../common.module';
import { DataTableModule } from '../data-table/data-table.module';
import { OrganizationService } from '../../services/organization.service';
import { OrganizationGuardService } from '../../../auth/guards/organization-guard.service';
import { OrganizationResolver } from '../../resolvers/organization.resolver';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrganizationComponent } from '../../../admin/components/organization/organization.component';
import { OrganizationWellsComponent } from './components/organization-wells/organization-wells.component';
import { OrganizationWrapperComponent } from './components/organization-wrapper/organization-wrapper.component';
import { RouterModule } from '@angular/router';
import { WellsModule } from '../../../wells/wells.module';
import { OrganizationWellDetailsComponent } from './components/organization-well-details/organization-well-details.component';
import { OrgFilePageComponent } from './org-file-page.component';
import { OrganizationChiefsOrdersComponent } from './components/organization-chiefs-orders/organization-chiefs-orders.component';
import { AgGridModule } from 'ag-grid-angular';
import { ChiefsOrdersActionsComponent } from './components/organization-chiefs-orders/chiefs-orders-actions/chiefs-orders-actions.component';
import { OrganizationFinancialAssuranceComponent } from './components/organization-financial-assurance/organization-financial-assurance.component';
import { OrganizationIssuesComponent } from './components/organization-issues/organization-issues.component';
import { OnBaseOrganizationDocumentsComponent } from './components/on-base-organization-documents/on-base-organization-documents.component';
import { OrganizationMassMailingComponent } from './components/organization-mass-mailing.component';
import { OrganizationComplianceReportingComponent } from './components/organization-compliance-reporting/organization-compliance-reporting.component';
import { IssuesModule } from '../../../issues/issues.module';
import { OrgContactEditorModalComponent } from './org-contact-editor-modal.component';


@NgModule({
    imports: [
        CommonModule,
        LunaCommonModule,
        FormsModule,
        ReactiveFormsModule,
        DataTableModule,
        WellsModule,
        RouterModule,
        IssuesModule,
        AgGridModule//.withComponents([])
    ],
    declarations: [
        OrganizationDetailComponent,
        OrganizationComponent,
        OrganizationEditComponent,
        CommunicationSelectorComponent,
        OrganizationContactsComponent,
        OrganizationDepartmentsComponent,
        OrganizationFilesComponent,
        OrganizationFormComponent,
        OrganizationHistoryComponent,
        OrganizationListComponent,
        OrganizationWellsComponent,
        OrganizationNotesComponent,
        OrganizationWrapperComponent,
        OrganizationWellDetailsComponent,
        OrgFilePageComponent,
        OrganizationChiefsOrdersComponent,
        ChiefsOrdersActionsComponent,
        OrganizationFinancialAssuranceComponent,
        OrganizationIssuesComponent,
        OnBaseOrganizationDocumentsComponent,
        OrganizationMassMailingComponent,
        OrganizationComplianceReportingComponent,
        OrgContactEditorModalComponent
    ],
   
    providers: [
        OrganizationService,
        OrganizationResolver,
        OrganizationGuardService
    ],
    exports: [
        OrganizationDetailComponent,
        OrganizationComponent,
        OrganizationWellsComponent,
        OrganizationEditComponent,
        CommunicationSelectorComponent,
        OrganizationContactsComponent,
        OrganizationDepartmentsComponent,
        OrganizationFilesComponent,
        OrganizationFormComponent,
        OrganizationHistoryComponent,
        OrganizationListComponent,
        OrganizationNotesComponent,
        OrganizationFinancialAssuranceComponent,
        OrganizationIssuesComponent,
        OrganizationMassMailingComponent,
        OrganizationComplianceReportingComponent
    ]
})
export class OrganizationModule { }
